export const noteConstants = {
  WORKING_NOTE_ID: "NOTE_ID",
  SELECTED_NOTE: "VIEW_SELECTED_NOTE",
  WORKING_NOTE_LOCATION: "NOTE_LOCATION",
  NOTE_LIST: "LIST_OF_NOTES",
  NOTE_PERMISSION: "NOTE_PERMISSION_CHECK",
  NOTE_VIEW_PERMISSION: "NOTE_VIEW_PERMISSION_CHECK",
  NOTE_CREATE_PERMISSION: "NOTE_CREATE_PERMISSION_CHECK",
  NOTE_MERGE_PERMISSION: "NOTE_MERGE_PERMISSION_CHECK",
  NOTE_BULK_RESOLVE_PERMISSION: "NOTE_BULK_RESOLVE_PERMISSION_CHECK"
};



// WEBPACK FOOTER //
// ./src/_constants/note.constants.js